import React from 'react'

function Stripes() {
    return (
        <pattern
            id="stripes"
            width="8"
            height="8"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(30)"
        >
            <rect
                width=".5"
                height="8"
                opacity=".5"
                transform="translate(0,0)"
                fill="#32858d"
            />
        </pattern>
    )
}

export default Stripes
